import { createAxiosInstance, getModificaciones, indexBy, esEntero, attachFilesToEntity } from "../utils/helpers";
import { API_URL } from ".";
import * as types from './types'
import { displayMessages, getParameterByName, uploadFiles } from "./common";
import { toast } from "react-toastify";
import moment from 'moment';
import history from "../utils/history";
import ip from 'ip';
import FileDownload from 'react-file-download';

import { getSolicitud as getSolicitudOS } from './otrosi'


export function getSolicitud(id) {
    const  axios = createAxiosInstance()
    return (dispatch) => {
        axios.get(`${API_URL}/solicitudes/bienes-investigacion/${id}`)
            .then(res => {
                const {solicitud, aprobadores} = res.data
                let cotizacionesAprobadas = [];
                let tipo_almacen = solicitud.tipo === 6 ? 'Laboratorio' : 'Materiales'

                dispatch(getParameterByName("ALMACEN"))

                for (let index = 0; index < solicitud.bienes.length; index++) {
                    cotizacionesAprobadas = solicitud.bienes[index].cotizaciones.filter(ele => ele.estado === 4)
                    solicitud.bienes[index].cotizaciones_aprobar = cotizacionesAprobadas;
                }

                for (let i = 0; i < aprobadores.length; i++) {
                    for (let j = 0; j < aprobadores[i].aprobaciones.length; j++) {
                        aprobadores[i].aprobaciones[j].selected = aprobadores[i].aprobaciones[j].estado === 2
                    }
                }
                
                dispatch({
                    type: types.OBTENER_SOLICITUD_BIENES_INVESTIGACION,
                    payload: {
                        solicitud,
                        aprobadores,
                        tipo_almacen
                    }
                })
            })
            .catch(err => {
                displayMessages(dispatch, err)
            })
    }
}

export function seleccionarMoneda(moneda='COP') {
    return (dispatch) => {
        dispatch({ type: types.SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1, payload: { moneda} })
    }
}


export function updateSolicitudBI() {
    const axios = createAxiosInstance()

    return (dispatch, getState) => {

        dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: true })

        const { solicitudBI } = getState()

        const modificar = solicitudBI.get('addModificacion')

        const remove = solicitudBI.get('remove')

        const errors = validateSolicitud(solicitudBI.get('solicitud'), modificar)        

        if (errors.length > 0) {

            errors.forEach(x => {
                toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            })

            dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })

        } else {


            let BienesNew = solicitudBI.getIn(['solicitud', 'bienes'])
            let BienesOld = solicitudBI.getIn(['unchaged', 'bienes'])

            let files = [];
            let modificaciones = [];


            const comprasDirectas = BienesNew.filter(bien => bien.get('compra_directa') && bien.get('factura_compra_directa'))
                                    .map(bien => bien.get('factura_compra_directa'))

            if (comprasDirectas.count() > 0 && solicitudBI.get('estado') >= 4 && solicitudBI.get('estado') <= 6) {
                files = attachFilesToEntity("FacturaCompraDirecta", comprasDirectas)
            }            
            
            if (modificar) {
                modificaciones = addModificacion(solicitudBI.get('solicitud'))
            } else {
                modificaciones = getModificaciones(BienesNew, BienesOld, 'BienesDetalle', switchBienes)
            }
            
            modificaciones = [...modificaciones, ...remove]

            modificaciones = addMoneda(solicitudBI.get('moneda'), modificaciones)

            modificaciones = addProveedoresExternos(modificaciones)
            
            axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitudBI.get('id')}`, modificaciones)
            .then(res => {
                const solicitud = res.data.solicitud
                const aprobadores = res.data.aprobadores
                const fn1 = () => dispatch({ type: types.ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: { solicitud, aprobadores } })
                const fn2 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
                const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
                dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3]))
            })
            .catch(err => {
                displayMessages(dispatch, err)
                dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })
            })
            


        }
    }
}

export function addFile(url, actions) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile','data'])
        const files = [data]
        actions.push(() => displayMessages(dispatch, { success: 'Los archivos han sido guardados exitosamente' }))
		dispatch(uploadFiles(url, files, actions))
	}
}

export function removeFiles() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fns = []
		getState().solicitudBI.getIn(['solicitud', 'adjuntos']).filter(a => a.get('id') && a.get('selected')).map(a => {
			fns.push(() => axios.delete(`${API_URL}/files/${a.get('id')}`))
        })
        const id = getState().solicitudBI.get('id')
		Promise.all(fns.map(x => x()))
		.then(() => {			
            displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })            
            dispatch(getSolicitud(id))
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}




export function toggleAllCotizacion(path, value) {
    return {
        type: types.SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION,
        payload: {
            path,
            value
        }
    }
}

export function addCotizacion(path, indexServicio) {

	return (dispatch, getState) => {

		const cotizaciones = getState().solicitudBI.getIn(['solicitud', 'bienes', indexServicio, 'cotizaciones'])
		const numcotizaciones = cotizaciones ? cotizaciones.count() : 0

		if (numcotizaciones >= 10) {
			toast.warning('Solo es permitido agregar diez(10) proveedores', { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			dispatch({ type: types.ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION, payload: { path, indexServicio} })
		}
	}
}



export function addProveedorCotizacion(payload) {
    return (dispatch, getState) => {

        const path = payload.path.split('.')
        const bienes = getState().solicitudBI.getIn(path).filter(b=>b.get('selected'))

        if (bienes.count() == 0) {
            toast.warn(`Debe tener al menos un bien seleccionado para agregar un proveedor`, { bodyClassName: 'toastify-content toastify-warning' })
        } else {

            dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION, payload })

            dispatch(
                {
                    type: types.ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION,
                    payload: {
                        entity: 'Solicitude',
                        id: getState().solicitudBI.get('id'),
                        attribute: 'bienes'
                    }
                }
            )

        }
    }
}









export function removeProveedorCotizacion(proveedor) {
    return (dispatch) => {
        dispatch({ 
            type: types.REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION, 
            payload: {
                bien_id: proveedor.get('bien_id'),
                proveedor_id: proveedor.get('id')
            } 
        })
    }
}








export function addCotizacionAprobar(path) {
    return {
        type: types.ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION,
        payload: {
            path
        }
    }
}

export function seleccionarCotizacionAprobar(cotizacion_id, bien_idx, cotizacion_aprobar_idx) {
    return (dispatch, getState) => {
        const cotizacionesAprobar = getState().solicitudBI.getIn(['solicitud', 'bienes', bien_idx, 'cotizaciones_aprobar'])
			.filter(cot => cot.get('id') == Number(cotizacion_id))
        
        if (cotizacionesAprobar.count() > 0) {
			return toast.warn(`El proveedor ya ha sido seleccionado`, { bodyClassName: 'toastify-content toastify-warning' })
        }
        
        return dispatch({
            type: types.SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION,
            payload: {
                cotizacion_id,
                bien_idx,
                cotizacion_aprobar_idx
            }
        })
    }
}

// export function removeProveedorCotizacion(path) {
//     return { type: types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION, payload: { path } }
// }




export function updateInputs(path, value, id = null, immutable = true) {

    return (dispatch) => { 

        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1, payload: { path, value, immutable } })
        fn0(dispatch)

        const pathArray = path.split('.')

		let entity = esEntero(pathArray.slice(-2)[0]) ? pathArray.slice(-3)[0] : pathArray.slice(-2)[0]
        const attribute = pathArray.slice(-2)[1] 
        
        switch (entity) {
			
			case 'solicitud':
				entity = 'Solicitude'
			break

            case 'bien':
            case 'bienes':
				entity = 'BienesDetalle'
            break           
            

            case 'cotizacion':
            case 'cotizacione':
            case 'cotizaciones':
            case 'cotizaciones_aprobar':
				entity = 'Cotizacione'
            break


			case 'documento':
			case 'documentos':
				entity = 'Documento'
            break
            
        }
        

		if (id) {
			const fn2 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION, payload: { id, entity, attribute, value, action: 'edit' } })
			fn2(dispatch)
		}

    }
}

export function addGroupOrders() {
    return {
        type: types.ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION,
    }
}

export function removeGroupOrders() {
    return {
        type: types.REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION,
    }
}

// export function recomendarCotizacion(bien_idx, cotizacion_aprobar_idx) {
// 	return (dispatch) => {
// 		dispatch({
// 			type: types.CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION,
// 			payload: {
//                 bien_idx,
//                 cotizacion_aprobar_idx
// 			}
// 		})
// 		dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })
// 	}
// }



export function recomendarCotizacion(bien_id, proveedor_id) {
	return (dispatch) => {
		dispatch({
			type: types.CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION,
			payload: {
                bien_id,
                proveedor_id
			}
		})
		dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })
	}
}




export function seleccionarAprobacion(bien_id, aprobador_id, aprobacion_id) {
    return {
        type: types.CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION,
        payload: {
            bien_id,
            aprobador_id,
            aprobacion_id
        }
    }
}




export function registrarResultadoAprobacion(aprobaciones, result) {


    const axios = createAxiosInstance(); 
    return (dispatch, getState) => {

        const solicitud = getState().solicitudBI.get('solicitud')
        const errors = result > 0 ? validateAprobacion(aprobaciones, result) : validateAprobacion(aprobaciones.first().get('observaciones'), result)
		
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

            // const BienesNew = getState().solicitudBI.getIn(['solicitud', 'bienes'])
            // const BienesOld = getState().solicitudBI.getIn(['unchaged', 'bienes'])
            // const modificaciones = getModificaciones(BienesNew, BienesOld, 'BienesDetalle', switchBienes)

            const modificaciones = []

			aprobaciones.filter(f => f.getIn(['cotizacione', 'recomendado'])).map(a => {

				modificaciones.push({
					id: a.get('id'),
					entity: 'Aprobacione',
					value: { estado: result, ip: ip.address(), observaciones: aprobaciones.first().get('observaciones') },
					action: 'edit'
                })
                
                const bienId = a.getIn(['cotizacione', 'bienes', 0, 'id'])
                const bienIdx = getState().solicitudBI.getIn(['solicitud', 'bienes']).findIndex(b => b.get('id') == bienId)
                const cantidad = getState().solicitudBI.getIn(['solicitud', 'bienes', bienIdx, 'cantidad_solicitada'])
                const estado = getState().solicitudBI.getIn(['solicitud', 'bienes', bienIdx, 'estado'])
                const descripcion = getState().solicitudBI.getIn(['solicitud', 'bienes', bienIdx, 'descripcion'])
                const observaciones = getState().solicitudBI.getIn(['solicitud', 'bienes', bienIdx, 'observaciones'])

                modificaciones.push({
                    id: bienId,
                    entity: 'BienesDetalle',
                    value: { 
                        cantidad_solicitada: cantidad, 
                        descripcion,
                        observaciones,
                        estado: result > 0 ? estado : 0 
                    },
                    action: 'edit'
                })
            })  


            dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION, payload: true }))

			axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud.get('id')}`, modificaciones)
            .then(res => {
                const {solicitud, aprobadores} = res.data
                if (solicitud.estado === 0) {
                    history.push(window.FOLDER + '/solicitudes/abiertas')
                    displayMessages(dispatch, { success: 'La solicitud ha sido anulada' })
                } else {
                    if (solicitud.documento_origen) {
                        const fn1 = (d) => d(getSolicitudOS(solicitud.id))
                        fn1(dispatch)
                    }
                    dispatch(({ type: types.ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: { solicitud, aprobadores } }))
                    displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })
                }
                dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION, payload: false }))
            })
            .catch(err => {
                displayMessages(dispatch, err)
                dispatch(({ type: types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION, payload: false }))
            })
            


		}
    }
}


export function displayModalCreateDocumento(show, title, mode, indexDocumento) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const proveedor = getState().solicitudBI.getIn(['solicitud', 'documentos', indexDocumento, 'proveedor_id'])
		const fn0 = () => axios.get(`${API_URL}/plantillas`)
		const fn1 = () => axios.get(`${API_URL}/garantias`)
		const fn2 = () => axios.get(`${API_URL}/documentos/contratos-anuales`, { params: { proveedor }})
		Promise.all([fn0(), fn1(), fn2()])
		.then(res => {
			const plantillas = res[0].data.data
			const garantias = res[1].data.data
			const contratos = res[2].data
			dispatch({
                type: types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION,
                payload: { show, title, mode, indexDocumento, plantillas, garantias, contratos } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}

export function displayModalCompraDirecta(show, title, bien_id, cotizacion) {
    return {
        type: types.MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION,
        payload: {
            title,
            show,
            bien_id,
            cotizacion
        }
    }
}

export function addFileCompraDirecta(path) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (data.get('clasificacion') && data.get('clasificacion') != 'Facturas') errors.push('Se requiere adjuntar un archivo de tipo Factura')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1, payload: {path, value: data, immutable: true} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

// export function createOrUpdateCompraDirecta() {
//     return (dispatch, getState) => {
//         const documentoNew = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'data'])
//         const cot_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'cot_id'])
//         const bien_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'bien_id'])
//         const cotizacion_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones']).findIndex(cot => cot.get('id') === cot_id)
//         let bien_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones', cotizacion_idx, 'bienes']).findIndex(bien => bien.get('id') === bien_id)
//         const errors = validateFacturaCompraDirecta(documentoNew)
//         if (errors.length) {
//             errors.forEach(x => {
//                 toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
//             })
//         } else {
//             dispatch(displayModalCompraDirecta(false))
//             dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))
//             bien_idx = getState().solicitudBI.getIn(['solicitud', 'bienes']).findIndex(bien => bien.get('id') === bien_id)
//             dispatch(updateInputs(`solicitud.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))
            
//         }
//     }
// }


export function createOrUpdateCompraDirecta() {
    return (dispatch, getState) => {

        const documentoNew = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'data'])
        const cot_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'cot_id'])
        const bien_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'bien_id'])
        const cotizacion_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones']).findIndex(cot => cot.get('id') === cot_id)

        let bien_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones', cotizacion_idx, 'bienes']).findIndex(bien => bien.get('id') === bien_id)
        const errors = validateFacturaCompraDirecta(documentoNew)

        if (errors.length) {
            errors.forEach(x => {
                toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            })
        } else {
            dispatch(displayModalCompraDirecta(false))
            dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))
            bien_idx = getState().solicitudBI.getIn(['solicitud', 'bienes']).findIndex(bien => bien.get('id') === bien_id)
            dispatch(updateInputs(`solicitud.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))

            if (documentoNew.get('proveedor','nombre'))
                dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.proveedor_nombre_cp`, documentoNew.getIn(['proveedor','nombre']), cot_id))
            else
                dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.proveedor_nombre_cp`, documentoNew.get(['razon_social']), cot_id))
            
        }
    }
}

export function addGarantia(checked, index, id) {
    return {
        type:  types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION,
        payload: {
            index,
            id,
            checked
        }
    }
}

export function registerCancelacion() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {

        const solicitud = getState().solicitudBI.get('solicitud').set('estado', 0)
        const errors = validateSolicitud(solicitud)

        if (errors.length > 0) {
            errors.forEach(x => {
                toast.warning(x, {
                    bodyClassName: 'toastify-content toastify-warning'
                })
            })
        } else {
            const modificaciones = []
            modificaciones.push({
                id: solicitud.get('id'),
                entity: 'Solicitude',
                value: {
                    estado: 0,
                    motivo_cancelacion: solicitud.get('motivo_cancelacion'),
                    fecha_cancelacion: moment().format('YYYY-MM-DD')
                },
                action: 'edit'
            })

            axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud.get('id')}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn0 = (d) => d({
                        type: types.ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, //Bug corregido sin probar
                        payload: {
                            solicitud,
                            aprobadores
                        }
                    })
                    const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', {
                        bodyClassName: 'toastify-content toastify-success'
                    })
                    fn0(dispatch)
                    fn1()

                    if (solicitud.documento_origen) {
						const fn2 = (d) => d(getSolicitudOS(solicitud.id))
						fn2(dispatch)
					}		
                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })
        }
    }
}

export function createOrUpdateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {


		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION, payload: true }) 
        const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION, payload: false })
        const fn4 = (d) => d({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: true })

		fn0(dispatch)
		const fn3 = (d) => d(displayModalCreateDocumento(false))
		const solicitud = getState().solicitudBI.get('id')
		const data = getState().solicitudBI.get('modalCreateDocumento')	

		let documentoNew = data.get('data')
		let documentoOld = data.get('unchanged')
		const tipoDocumento = documentoNew.get('tipo')
		
		if ((tipoDocumento == 1) || (tipoDocumento == 3)) {
			documentoNew = documentoNew.set('fecha_inicio', moment().format('YYYY-MM-DD'))
        }
        
        if (tipoDocumento == 2 && !documentoNew.get('fecha_inicio')) {
            documentoNew = documentoNew.set('fecha_inicio', moment().format('YYYY-MM-DD'))
        } else if (tipoDocumento == 2) {
            documentoNew = documentoNew.set('fecha_inicio', moment(documentoNew.get('fecha_inicio')).format('YYYY-MM-DD'))
        }

		if (tipoDocumento == 4) {
			const fecha_inicio = getState().solicitudBI.getIn(['solicitud', 'documento_origen', 'fecha_inicio'])
			documentoNew = documentoNew.set('fecha_inicio', moment(fecha_inicio).format('YYYY-MM-DD'))
		}
        
		const errors = validateDocumento(documentoNew, data.get('contratoanual'))

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            })
            fn1(dispatch)
		} else {
			
			documentoOld = documentoOld.set('garantias', indexBy(documentoOld.get('garantias'), 'id'))
			documentoNew = documentoNew.set('garantias', indexBy(documentoNew.get('garantias'), 'id'))
			const modificaciones = getModificaciones(documentoNew, documentoOld, 'Documento', switchDocumento)
			axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud}`, modificaciones)
				.then(res => {
					const solicitud = res.data.solicitud
					const aprobadores = res.data.aprobadores					
                    const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: { solicitud, aprobadores }})
                    fn1(dispatch)
					fn2(dispatch)
                    fn3(dispatch)
                    fn4(dispatch)
					displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		}
	}
}

export function previewDocumento(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const documento = getState().solicitudBI.getIn(['modalCreateDocumento', 'data'])
        const tipo = getState().common.getIn(['enums', 'documentos', 'tipos', `${documento.get('tipo')}`, 'NOMBRE'])

		axios.post(`${API_URL}/solicitudes/bienes-investigacion/view/${id}`, {documento}, { responseType: 'arraybuffer' })
		.then(res => {			
			FileDownload(res.data, `PREV-${tipo}.pdf`);
		})
		.catch(err => {			
			const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)))
			const obj = {
				response: {
					data: decodedString,
					status: 422
				}
			}
			displayMessages(dispatch, obj)
		})
	}
}




export function addSolicitudBienesItem() {
	return {
		type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1
	}
}


export function removeSolicitudBienesItem() {
	return (dispatch, getState) => {

        const bienes = getState().solicitudBI.getIn(['solicitud', 'bienes']).filter(x => x.get('id') && x.get('selected'))
        
        const modificaciones = []

        bienes.valueSeq().forEach(bien => {

            const id = bien.get('id')
            const cencos = bien.get('cencos')

            cencos.valueSeq().forEach(c => {
                modificaciones.push({
                    entity: 'DisCencoBiene',
                    id: c.getIn(['pivot', 'id']),
                    action: 'delete'
                })
            })

            modificaciones.push({
                entity: 'BienesDetalle',
                id: bien.get('id'),
                action: 'delete'
            })

        })

        dispatch({ type: types.ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1, payload:{remove:modificaciones} })
       
	}
}




export function toggleSelectAllProveedores(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_BIENES, payload: checked })
	}
}

export function calculateIva() {
	return (dispatch) => {
		dispatch({ type: types.CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION })
	}
}


export function enviarComentario() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud_id = getState().solicitudBI.getIn(['solicitud', 'id'])
		const usuario_id = getState().common.getIn(['user', 'id'])
		const id = getState().solicitudBI.getIn(['comentario','id'])
		const comentario = getState().solicitudBI.getIn(['comentario','texto'])
        const modificaciones = []

		if (id == null) {

			modificaciones.push({ 
				entity: 'Foro', 
				action: 'add', 
				id: null,
				value: {
					solicitud_id,
					usuario_id,
					comentario
				}
			})

		} else {

			modificaciones.push({
				id,
				entity: 'Foro',
				value: { comentario },
				action: 'edit'
			})
		}

		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1, payload: true })
		const fn2 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1, payload: false })

		fn1(dispatch)
		axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud_id}`, modificaciones)
		.then(res => {
			const foros = res.data.solicitud.foros	
			const fn3 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1, payload: { foros } })
			fn3(dispatch)
			fn2(dispatch)
		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn2(dispatch)
		})		
	}
}

export function editarComentario( id ) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1, payload: { id } })
		fn1(dispatch)
	}
}

export function eliminarComentario(id) {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud = getState().solicitudBI.getIn(['solicitud', 'id'])
        const modificaciones = []
		modificaciones.push({ entity: 'Foro', id, action: 'delete'})
        axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud}`, modificaciones)
        .then(res => {
			const foros = res.data.solicitud.foros	
			const fn1 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1, payload: { foros } })
            fn1(dispatch)
			displayMessages(dispatch, { success: 'La eliminacion han sido realizadas exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })		
	}
}



/**
 * Verifica que las cotizaciones a aprobar o rechazar tengan los datos necesarios
 * @param {Object} data: datos de la cotizacion
 * @param {Number} respuesta: 2->aprobado, 0->rechazado
 * @returns {Array} errors: Lista de errores
 */
// const validateAprobacion = (data, respuesta) => {
// 	const errors = []
// 	if (respuesta == 2 && data.filter(x => x.get('estado') == 3).count() == 0) errors.push('Debe seleccionar una cotización para aprobar')
// 	if (respuesta == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')

// 	return errors
// }


const validateAprobacion = (data, respuesta) => {
	const errors = []
	if (respuesta == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')

	return errors
}


/**
 * Valida que todos los campos esten diligenciados
 * @param {Object} data 
 */
const validateFacturaCompraDirecta = (data) => {
    const errors = [];
    
    if (!data.get('razon_social') && !data.getIn(['proveedor', 'nombre'])) errors.push("Debe ingresar un proveedor")
    //if (!data.get('nit')) errors.push("Debe ingresar el nit de la empresa")
    if (!data.get('no_factura')) errors.push("Debe ingresar el número de la factura")
    if (!data.get('fecha_compra')) errors.push("Ingrese una fecha de compra válida")
    if (!data.get('medio_pago')) errors.push("Debe ingresar una forma de pago")
    if (!data.get('valor_compra')) errors.push("Debe ingresar el valor de la compra")
    if (!data.get('adjunto')) errors.push("Debe adjuntar el archivo de la factura")
    const today = moment()
    if (data.get('fecha_compra') && moment(data.get('fecha_compra')).isAfter(today)) errors.push("La fecha de compra no debe ser superior a la de hoy")

    return errors
}

/**
 * 
 * @param {*} data 
 * @param {*} escontratoanual 
 */
const validateDocumento = (data, escontratoanual=false) => {
	const errors = []
	
	if (Number(data.get('tipo')) === 0) errors.push('El campo tipo de documento es obligatorio')
	if (data.get('tipo') == 2 && !data.get('fecha_inicio')) errors.push('El campo fecha inicio es obligatorio')
	if (!data.get('fecha_entrega')) errors.push('El campo fecha entrega es obligatorio')

	if (data.get('tipo') == 2 && data.get('fecha_inicio')) {
        const today = moment().format('YYYY-MM-DD')
		if (moment(today).isAfter(data.get('fecha_inicio'))) errors.push('La fecha de inicio no debe ser inferior a hoy')
	}

	if (data.get('tipo') == 2 && data.get('fecha_inicio') && data.get('fecha_entrega')) {
		if (moment(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega'))) errors.push('La fecha entrega no debe ser inferior a la fecha de inicio')
    }   
    

	if (data.get('tipo') != 4 && Number(data.get('plantilla_id')) === 0) errors.push('El campo plantilla es obligatorio')
	if (Number(data.get('anticipo')) > 50) errors.push('El anticipo no debe ser superior al 50%')
    if (Number(data.get('anticipo')) > 0 && !data.get('pago_anticipo')) errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo')
    if (Number(data.get('anticipo')) > 0 && !data.get('forma_pago_anticipo')) errors.push('La forma de pago de anticipo es obligatioria si hay anticipo')


	if (escontratoanual) {
		if (Number(data.get('documento_id')) === 0) errors.push('El campo número de contrato es obligatorio')
    }

    const input_iva = parseFloat(Number(getTotalConIva(data)).toFixed(2))
    const aiu_total = parseFloat(Number(data.get('aiu_total')).toFixed(2))

    
    //Lo mando a quitar Oscar el dia 12/07/2019 via Skype
    // if (input_iva !== aiu_total && data.get('tipo') != 4) {
	// 	errors.push('El valor total de los bienes es diferente al valor total del IVA')
    // }


	if (!data.get('almacen')) {
		errors.push('El campo Almacén es obligatorio')
	}


    	
	return errors
}

/**
 * Con los datos de la solicitud, valida que pase las restricciones y retorna una lista de inconsistencias.
 * @param {Object} solicitud
 * @returns {Array} errors
 */
const validateSolicitud = (solicitud, extra=null) => {

    const errors = [];

    if (solicitud.get('estado') === 1) {
        solicitud.get('bienes').valueSeq().forEach((ele, idx) => {

            // if (ele.get('cantidad_solicitada') > ele.get("cantidad_requerida"))
            //     errors.push(`La cantidad solicitada debe ser menor o igual a la cantidad requerida. ${ele.get('descripcion')}`);


            if (!ele.get('descripcion'))
                errors.push(`Debe indicar la descripcion en el bien # ${idx+1}`);

            if (ele.get('cantidad_solicitada') < 0)
                errors.push(`La cantidad solicitada no debe ser menor a cero. ${ele.get('descripcion')}`)

            // if (!ele.get('item'))
            //     errors.push(`Debe seleccionar el item del ERP correspondiente. ${ele.get('descripcion')}`);

            if (!ele.get('unidad'))
                errors.push(`Debe indicar la unidad para ${ele.get('descripcion')}`);

            if (!ele.get('cantidad_solicitada'))
                errors.push(`Debe indicar la cantidad solicitada para ${ele.get('descripcion')}`);



        })
    } else if (solicitud.get('estado') === 8) {


        if (extra == false) {

            if (!solicitud.getIn(['bienes', 0, 'fecha_cotizaciones']) || solicitud.getIn(['bienes', 0, 'fecha_cotizaciones']) == '-0001-11-30 00:00:00')
                errors.push(`El campo fecha cotizaciones es obligatorio`)    
    
            if (solicitud.getIn(['bienes', 0, 'fecha_cotizaciones']) && moment().isSameOrAfter(solicitud.getIn(['bienes', 0, 'fecha_cotizaciones'])))
                errors.push(`La fecha de cotizaciones no debe ser inferior a la de hoy`)

        }


        solicitud.get('bienes').valueSeq().forEach((ele,idx) => {            

            const descripcion = ele.get('descripcion') ? ele.get('descripcion') : `Bien # ${idx + 1}`

            if (!ele.get('descripcion'))
                errors.push(`Debe indicar la descripcion en ${descripcion}`);

            if (ele.get('cantidad_solicitada') < 0)
                errors.push(`La cantidad solicitada no debe ser menor a cero. ${descripcion}`)

            // if (!ele.get('item'))
            //     errors.push(`Debe seleccionar el item del ERP correspondiente. ${descripcion}`);

            if (!ele.get('unidad'))
                errors.push(`Debe indicar la unidad para ${descripcion}`);

            if (!ele.get('cantidad_solicitada'))
                errors.push(`Debe indicar la cantidad solicitada para ${descripcion}`);


            if (!ele.get('compra_directa') && ele.get('cantidad_solicitada') > 0 && extra==false) {

                if (ele.get('cotizaciones').count() == 0)
                    errors.push(`Se requiere al menos un proveedor o una compra directa para ${descripcion}`)

                // if (ele.get('cotizaciones').count() > 0 && ele.get('cotizaciones').filter(c => c.get('proveedore') == null).count() > 0)
                //     errors.push(`Todos los campos de los bienes son requeridos`)

            }


        })



    } else if (solicitud.get('estado') >= 2 ) {

        solicitud.get('bienes').filter(b => b.get('cantidad_solicitada') > 0 && b.get('estado') == 1).map((bien,idx) => {

            const descripcion = bien.get('descripcion') ? bien.get('descripcion') : `Bien # ${idx + 1}`

            if (!bien.get('compra_directa') && bien.get('cantidad_solicitada') > 0 && extra==false) {

                if (bien.get('cotizaciones').count() == 0)
                    errors.push(`Se requiere al menos un proveedor o una compra directa para ${descripcion}`)

                // if (bien.get('cotizaciones').count() > 0 && bien.get('cotizaciones').filter(c => c.get('proveedore') == null).count() > 0)
                //     errors.push(`Todos los campos de los bienes son requeridos`)

            }

            bien.get('cotizaciones').filter(c => c.get('recomendado')).map(cotizacion => {
                let target = `${bien.getIn(['item', 'descripcion'])}`

                //let tiene_proveedor = false;
                let tiene_proveedor = cotizacion.get('proveedor_id') ? true : false;
                
                if (bien.get('compra_directa')) {
                    // Si compra_directa es true, verifica si proveedor_id y proveedor_nombre_cp son válidos
                    const proveedorId = cotizacion.get('proveedor_id');
                    const proveedorNombreCp = cotizacion.get('proveedor_nombre_cp');

                    // Considera válido el proveedor_id si es un número y no es nulo
                    const esProveedorIdValido = typeof proveedorId === 'number' && proveedorId !== null;

                    // Considera válido el proveedor_nombre_cp si es un string no vacío y no es nulo
                    const esProveedorNombreCpValido = typeof proveedorNombreCp === 'string' && proveedorNombreCp !== null && proveedorNombreCp.trim() !== '';

                    // Se considera que tiene proveedor si al menos uno de los dos es válido
                    tiene_proveedor = esProveedorIdValido || esProveedorNombreCpValido;
                }

                if (!cotizacion.get('cotizado')) errors.push(`El valor unitario de la cotización es obligatorio en el bien: ${target}`)
                if (!cotizacion.get('tiempo_entrega')) errors.push(`El tiempo de entrega de la cotización es obligatorio en el bien: ${target}`)
                if (tiene_proveedor === false) errors.push(`El proveedor de la cotización es obligatorio en el bien: ${target}`)
            })

        })


	} else if (solicitud.get('estado') === 0) {
        if (!solicitud.get('motivo_cancelacion')) errors.push('El campo motivo cancelación es obligatorio');
    }

    return errors;
}

/**
 * Ejecuta ajustes en los datos de cambios para enviar al servidor
 * @param {Object} change 
 * @param {Object} modificacion 
 * @param {Object} bienes 
 */
const switchBienes = (change, modificacion, bienes) => { 


	const path = [...modificacion.attribute]
    modificacion.attribute = path[1]
	switch (change.get('op')) {
        
		case 'add':
			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'create'
				modificacion.value.adjunto = null
                modificacion.value.proveedor_id = modificacion.value.proveedore.id
                modificacion.value.proveedore = null                
                modificacion.value.servicio = null
			} else if(modificacion.attribute === "cotizaciones_aprobar") {
				modificacion.action = 'create'
                modificacion.attribute = 'cotizaciones'
                modificacion.value.adjunto = null
                modificacion.value.proveedor_id = null
                modificacion.value.proveedore = null
                modificacion.value.servicio = null
            } else if(modificacion.attribute === "selected") {
                modificacion.action = 'hidden'                
            }
		break

		case 'replace':
			if (modificacion.attribute === 'cotizaciones' || modificacion.attribute === "cotizaciones_aprobar") {
				modificacion.attribute = path[3]
				modificacion.entity = 'Cotizacione'
				modificacion.id = bienes.getIn([...path.splice(0,3), 'id'])
			} else if (modificacion.attribute === 'item') {
                modificacion.attribute = "item_id"
                modificacion.value = bienes.getIn([...path.splice(0,3), 'id'])
            } else if (modificacion.attribute === 'factura_compra_directa') {
               if (bienes.getIn([...path.slice(0,2), 'id'])) {
                    modificacion.attribute = path[2]
                    modificacion.entity = 'FacturaCompraDirecta'
                    modificacion.id = bienes.getIn([...path.slice(0,2), 'id'])
                } else {
                    modificacion.entity = 'BienesDetalle',
                    modificacion.action = 'create'
                    delete modificacion.value.adjunto
                    delete modificacion.value.id
               }
            } else if(modificacion.attribute === "selected") {
                modificacion.action = 'hidden'                
            }
		break

		case 'remove':

		break


	}	
}

const addMoneda = (moneda, modificaciones) => { 
    modificaciones.forEach((m,i) => {
        if (m.value && m.entity == 'BienesDetalle' && m.attribute == 'cotizaciones' && m.action == 'create') {
            modificaciones[i].value.moneda = moneda ? moneda : 'COP'
        }
    })
    const modificacion ={
        action: 'hidden',
        entity: 'Parametro', 
        value: {
            moneda
        }
    }
    modificaciones.push(modificacion);
    return modificaciones
}


const addProveedoresExternos = (modificaciones) => {
    modificaciones.forEach((m,i) => {
        if (m.value && m.entity == 'BienesDetalle' && m.attribute == 'factura_compra_directa' && m.action == 'create') {
            if (m.value.proveedor) {
                modificaciones[i].value.razon_social = m.value.proveedor.nombre
                delete modificaciones[i].value.proveedor
            } else {
                modificaciones.push({
					entity: 'ProveedorExterno',
					value: {
						nombre: m.value.razon_social,
					},
					action: 'add'
				});
            }
        }
    })
    return modificaciones
}


/**
 * 
 * @param {*} change 
 * @param {*} modificacion 
 */
const switchDocumento = (change, modificacion) => {
    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]
    
    switch (modificacion.attribute) {
		case 'aiu_administracion_value':
		case 'aiu_imprevistos_value':
		case 'aiu_utilidad_value':
        case 'aiu_iva_utilidad_value':
        case 'aiu_total':
        case 'todos_detalles':
            modificacion.action = 'hidden'
            break
        case 'iva_value':
            if (modificacion.action === 'add') modificacion.action = 'replace'
    		break
    }
    
    switch (change.get('op')) {
        case 'add':
            if (modificacion.attribute === 'garantias') {
                modificacion.value = modificacion.value.id
                modificacion.action = 'attach'
            }
            break
        case 'remove':
            if (modificacion.attribute === 'garantias') {
				modificacion.action = 'detach'
            }
            break
    }
}

const switchFacturaCompraDirecta = (change, modification, facturaCP) => {
    const path = [...modification.attribute]
    modification.attribute = path[0]

    switch (change.get('op')) {
        case 'add':
            if (modification.entity === 'FacturaCompraDirecta') {
                modification.action = 'create'
            }
    }
}

const getTotalSinIva = (data) => {
    return data.get('detalles').reduce((acum, detalle) => {
        acum += detalle.get('valor') * detalle.get('cantidad')
        return acum
    }, 0)
}


const getTotalConIva = (data) => {
    return data.get('detalles').reduce((acum, detalle) => {
        acum += detalle.get('valor_con_iva') * detalle.get('cantidad')
        return acum
    }, 0)
}

const addModificacion = (solicitud) => {

    const modificaciones = []

	modificaciones.push({
		id: solicitud.get('id'),
		entity: 'Solicitude',
		value: {
			proyecto_evento: solicitud.get('proyecto_evento'),
			fecha_requerido: solicitud.get('fecha_requerido'),
            tipo: solicitud.get('tipo'),
		},
		action: 'edit'
    })


    const cencos = [];

    solicitud.getIn(['bienes', 0, 'cencos']).valueSeq().forEach(cenco => {
    	cencos.push({
    		cenco_id: cenco.getIn(['pivot', 'cenco_id']),
    		porcentaje: cenco.getIn(['pivot', 'porcentaje']),
    		rubro_id: cenco.getIn(['pivot', 'rubro_id'])
    	})
    })


	solicitud.get('bienes').valueSeq().forEach(bien => {
		if (bien.get('id')) {
			modificaciones.push({
				id: bien.get('id'),
				entity: 'BienesDetalle',
				value: {
                    descripcion: bien.get('descripcion'),
                    item_id: bien.getIn(['item', 'id']),
                    cantidad_requerida: bien.get('cantidad_requerida'),
                    cantidad_solicitada: bien.get('cantidad_solicitada'),
                    unidad: bien.get('unidad')
				},
				action: 'edit'
			})

		} else {
			// Se modifico el backend para aceptar una relacion
			modificaciones.push({
				entity: 'BienesDetalle',
				value: {
                    solicitud_id: solicitud.get('id'),
                    descripcion: bien.get('descripcion'),
                    item_id: bien.getIn(['item', 'id']),
                    cantidad_requerida: bien.get('cantidad_requerida'),
                    cantidad_solicitada: bien.get('cantidad_solicitada'),	
                    unidad: bien.get('unidad'),				
					estado: 1,
					cencos
				},
				action: 'add'
			})

        }
    })

	return modificaciones

}

export function crearAprobacionAdicionalBiene(aprobador, motivo) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const errors = validarSolicitudAprobacionAdicionalBiene(aprobador, motivo);
        if (errors.length > 0) {
            errors.forEach(x => {
                toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
            });
            return;
        }
        const solicitud = getState().solicitudBI.get('solicitud');
        const cotizaciones = solicitud.get('cotizaciones').filter(x => x.get('recomendado') === true);
        const modificaciones = [];
        if (cotizaciones && cotizaciones.size > 0) {
            cotizaciones.forEach(cotizacion => {
                modificaciones.push({
                    id: null,
                    entity: 'Aprobacione',
                    action: 'add',
                    value: {
                        cotizacion_id: cotizacion.get('id'),
                        aprobador_id: aprobador.id,
                        estado: 1, // Pendiente de aprobación
                        observaciones: motivo,
                        tipo: 3
                    }
                });
            });
        }
        axios.put(`${API_URL}/solicitudes/bienes-investigacion/${solicitud.get('id')}`, modificaciones)
            .then(res => {
                dispatch(getSolicitud(solicitud.get('id')));
            })
            .catch(err => {
                displayMessages(dispatch, err);
            });
    };
}

export const validarSolicitudAprobacionAdicionalBiene = (aprobador, motivo) => {
    const errors = [];
    if (!aprobador || !aprobador.id) errors.push('Debe seleccionar un aprobador adicional');
    if (!motivo || !motivo.trim()) errors.push('El motivo de la solicitud adicional es obligatorio');
    return errors;
}



// WEBPACK FOOTER //
// ./src/actions/solicitudbi.js